import AddIcon from '../assets/icons/add.svg';
import GoogleIcon from '../assets/icons/google.svg';
import TemplateIcon from '../assets/icons/template.svg';
import TextIcon from '../assets/icons/text.svg';
import NumberIcon from '../assets/icons/number.svg';
import CheckIcon from '../assets/icons/check-square.svg';
import ParagraphIcon from '../assets/icons/paragraph.svg';
import OptionIcon from '../assets/icons/option.svg';
import DropdownIcon from '../assets/icons/dropdown.svg';
import RatingIcon from '../assets/icons/rating.svg';
import TravelBookIcon from '../assets/icons/business-travel.svg';
import FeedBackIcon from '../assets/icons/online-consulting.svg';
import ContactIcon from '../assets/icons/help-desk.svg';
import AppointmentIcon from '../assets/icons/appointment.svg';
import FoodIcon from '../assets/icons/food.svg';
import StoreIcon from '../assets/icons/store.svg';
import EventIcon from '../assets/icons/event-analysis.svg';
import CalenderIcon from '../assets/icons/calender.svg';
import ImageIcon from '../assets/icons/image.svg';
import YoutubeIcon from '../assets/icons/youtube.svg';
import MinusIcon from '../assets/icons/minus-solid.svg';
import PageBreakIcon from '../assets/icons/page-break.svg';
import EmailIcon from '../assets/icons/email.svg';
import PhoneIcon from '../assets/icons/phone.svg';
import FileIcon from '../assets/icons/attachment.svg';
import FormulaIcon from '../assets/icons/function-1.svg';
import PaymentIcon from '../assets/icons/credit-card.svg';
import CalculatorIcon from '../assets/icons/calculation.svg';
import PageIcon from '../assets/icons/page.svg';
import AddressIcon from '../assets/icons/address.svg';

import uuid, { ObjectId } from '../utils/uuid';

let GOOGLE_AUTH_LINK = '/auth/google';
let GOOGLE_SHEET_AUTH_LINK = '/integration/gsheet';

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  GOOGLE_AUTH_LINK = 'http://localhost:3000/auth/google';
  GOOGLE_SHEET_AUTH_LINK = 'http://localhost:3000/integration/gsheet';
}

const LANGUAGES = [
  { name: 'English', code: 'en' },
  { name: 'Português', code: 'pt-br' },
  { name: 'Español', code: 'es' },
  { name: 'Indonesian', code: 'id' },
  { name: 'Français', code: 'fr' },
  { name: 'Italiano', code: 'it' },
  { name: 'Deutsche', code: 'de' },
  { name: 'Arabic', code: 'ar' },
  { name: '简体中文', code: 'zh' },
  { name: 'Russian', code: 'ru' },
];

const createMenuList = [
  {
    title: 'scratch.title',
    desc: 'scratch.description',
    icon: AddIcon,
    type: 'new',
  },
  {
    title: 'template.title',
    desc: 'template.description',
    icon: TemplateIcon,
    type: 'template',
  },
];

export const antdLocaleMap = {
  'pt-br': 'pt_BR',
  es: 'es_ES',
  id: 'id_ID',
  fr: 'fr_FR',
  it: 'it_IT',
  de: 'nl_BE',
  zh: 'zh_CN',
  ru: 'ru_RU',
};

const ToolBarHeaderMap = {
  HEADER: { default: 'Header', key: 'header' },
  TEXT: { default: 'Text Input', key: 'textInput' },
  RADIO: { default: 'Multiple Choice', key: 'radio' },
  CHECKBOX: { default: 'Checkboxes', key: 'checkbox' },
  DROPDOWN: { default: 'Dropdown', key: 'dropdown' },
  RATING: { default: 'Rating', key: 'rating' },
  DATE: { default: 'Date', key: 'date' },
  IMAGE: { default: 'Image', key: 'image' },
  VIDEO: { default: 'Video', key: 'video' },
  EMAIL: { default: 'Email', key: 'email' },
  PHONE: { default: 'Phone', key: 'phone' },
  FILE: { default: 'File Upload', key: 'file' },
  SECTION: { default: 'Section', key: 'section' },
  FORMULA: { default: 'Calculator', key: 'formula' },
  PAYMENT: { default: 'Payment', key: 'payment' },
  NUMBER: { default: 'Number', key: 'number' },
  DEFAULT: { default: 'question', key: 'default' },
};

const ITEMS = [
  {
    id: uuid(),
    type: 'TEXT',
    content: 'Text Input',
    key: 'textInput',
    icon: TextIcon,
    desc: 'Single line or multiple text area',
    initialValue: {
      questionId: uuid(),
      type: 'TEXT',
      validation: '',
      hint: '',
      description: '',
      label: 'Type a question',
      placeholderText: '',
      options: [],
      required: false,
    },
  },

  {
    id: uuid(),
    type: 'RADIO',
    content: 'Multiple Choice',
    key: 'multipleChoice',
    desc: 'Select an item with radio button',
    icon: OptionIcon,
    initialValue: {
      questionId: uuid(),
      type: 'RADIO',
      allowOther: false,
      hint: '',
      description: '',
      label: 'Choose one option',
      required: false,
      options: [
        {
          _id: ObjectId(),
          value: '1',
          label: 'option 1',
        },
        {
          _id: ObjectId(),
          value: '2',
          label: 'option 2',
        },
      ],
    },
  },
  {
    id: uuid(),
    type: 'CHECKBOX',
    content: 'Checkbox',
    key: 'checkboxes',
    desc: 'Select multiple options using checkbox',
    icon: CheckIcon,
    initialValue: {
      questionId: uuid(),
      type: 'CHECKBOX',
      label: 'Choose multiple options',
      hint: '',
      description: '',
      allowOther: false,
      required: false,
      options: [
        {
          _id: ObjectId(),
          value: '1',
          label: 'option 1',
        },
        {
          _id: ObjectId(),
          value: '2',
          label: 'option 2',
        },
      ],
    },
  },
  {
    id: uuid(),
    type: 'DROPDOWN',
    content: 'Dropdown',
    key: 'dropdown',
    icon: DropdownIcon,
    desc: 'Choose an option from dropdown',
    initialValue: {
      questionId: uuid(),
      type: 'DROPDOWN',
      hint: '',
      description: '',
      label: 'Select from list',
      required: false,
      options: [
        {
          _id: ObjectId(),
          value: '1',
          label: 'option 1',
        },
        {
          _id: ObjectId(),
          value: '2',
          label: 'option 2',
        },
      ],
    },
  },
  {
    id: uuid(),
    type: 'NUMBER',
    content: 'Number',
    key: 'numberInput',
    icon: NumberIcon,
    desc: 'Add a number input field',
    initialValue: {
      questionId: uuid(),
      type: 'NUMBER',
      validation: '',
      hint: '',
      description: '',
      label: 'Type a question',
      numberType: 'integer',
      placeholderText: '0',
      options: [],
      required: false,
    },
  },
  {
    id: uuid(),
    type: 'RATING',
    content: 'Rating',
    key: 'rating',
    icon: RatingIcon,
    desc: 'Add a rating type question',
    initialValue: {
      questionId: uuid(),
      type: 'RATING',
      hint: '',
      description: '',
      label: 'Rate your experience',
      required: false,
      options: [],
      ratingStyle: 'star',
    },
  },
  {
    id: uuid(),
    type: 'DATE',
    content: 'Date',
    key: 'date',
    icon: CalenderIcon,
    desc: 'Add a datetime picker',
    initialValue: {
      questionId: uuid(),
      type: 'DATE',
      datePickerMode: 'date',
      use12Hours: true,
      hint: '',
      description: '',
      label: 'Choose a date or date & time',
      required: false,
      options: [],
    },
  },
  {
    id: uuid(),
    type: 'SEPERATOR',
  },
  {
    id: uuid(),
    type: 'EMAIL',
    content: 'Email',
    key: 'emailInput',
    icon: EmailIcon,
    desc: 'Email input field',
    initialValue: {
      questionId: uuid(),
      type: 'EMAIL',
      validation: '',
      hint: '',
      description: '',
      label: 'Enter your E-mail',
      placeholderText: '',
      options: [],
      required: false,
    },
  },
  {
    id: uuid(),
    type: 'PHONE',
    content: 'Phone',
    key: 'phoneInput',
    icon: PhoneIcon,
    desc: 'Phone number input field',
    initialValue: {
      questionId: uuid(),
      type: 'PHONE',
      validation: '',
      hint: '',
      description: '',
      label: 'Enter your phone number',
      placeholderText: '',
      options: [],
      required: false,
    },
  },
  {
    id: uuid(),
    type: 'SEPERATOR',
  },
  {
    id: uuid(),
    type: 'HEADER',
    content: 'Title',
    key: 'title',
    icon: ParagraphIcon,
    desc: 'Add a title and description',
    initialValue: {
      questionId: uuid(),
      type: 'HEADER',
      validation: '',
      hint: '',
      description: '',
      label: 'Add Title here',
      placeholderText: '',
      options: [],
      required: false,
    },
  },
  {
    id: uuid(),
    type: 'IMAGE',
    content: 'Image',
    key: 'image',
    icon: ImageIcon,
    desc: 'Insert an image',
    initialValue: {
      questionId: uuid(),
      type: 'IMAGE',
      hint: '',
      description: '',
      label: 'Add an image here',
      required: false,
      options: [],
    },
  },
  {
    id: uuid(),
    type: 'VIDEO',
    content: 'Video',
    key: 'video',
    icon: YoutubeIcon,
    desc: 'Embed a video from Youtube, vimeo, etc',
    initialValue: {
      questionId: uuid(),
      type: 'VIDEO',
      hint: '',
      description: '',
      label: 'Add a video here',
      required: false,
      options: [],
    },
  },
];

const ADVANCED_ITEMS = [
  {
    id: uuid(),
    type: 'SECTION',
    content: 'Page',
    key: 'section',
    icon: PageIcon,
    desc: 'Embed a video from Youtube, vimeo, etc',
    initialValue: {
      questionId: uuid(),
      type: 'SECTION',
      label: '',
      allowBack: true,
      nextButtonText: 'Next',
      prevButtonText: 'Back',
      // hint: '',
      // description: '',
      // label: 'Add a video here',
      // required: false,
      // options: [],
    },
  },
  {
    id: uuid(),
    type: 'FILE',
    content: 'File Upload',
    key: 'file',
    icon: FileIcon,
    desc: 'Upload file(s)',
    initialValue: {
      questionId: uuid(),
      type: 'FILE',
      hint: '',
      description: '',
      label: 'Choose a file for upload',
      required: false,
      options: [],
    },
  },
  {
    id: uuid(),
    type: 'FORMULA',
    content: 'Calculator',
    key: 'formula',
    icon: CalculatorIcon,
    desc: 'Add calculations',
    initialValue: {
      questionId: uuid(),
      type: 'FORMULA',
      hint: '',
      description: '',
      required: false,
      label: 'Calculated value', //TODO: update in locale
      formulaRender: '',
      formula: {
        expression: '',
        variables: {},
      },
      hidden: false,
    },
  },
  {
    id: uuid(),
    type: 'PAYMENT',
    content: 'Payment',
    key: 'payment',
    icon: PaymentIcon,
    desc: 'Add a payment',
    initialValue: {
      questionId: uuid(),
      type: 'PAYMENT',
      merchants: [],
      hint: '',
      label: 'Payment',
      description: '',
      required: false,
      paymentAmountType: 'fixed',
      currency: 'USD',
    },
  },
  {
    id: uuid(),
    type: 'ADDRESS',
    content: 'Address',
    key: 'address',
    icon: AddressIcon,
    desc: 'Add an address',
    initialValue: {
      questionId: uuid(),
      type: 'ADDRESS',
      label: 'Address',
      description: '',
      fields: [
        {
          id: 'addressLine1',
          label: 'Address Line 1',
          required: true,
          enabled: true,
        },
        {
          id: 'addressLine2',
          label: 'Address Line 2',
          required: false,
          enabled: true,
        },
        {
          id: 'city',
          label: 'City',
          required: false,
          enabled: true,
        },
        {
          id: 'state',
          label: 'State',
          required: false,
          enabled: true,
        },
        {
          id: 'zip',
          label: 'Zip Code',
          required: false,
          enabled: true,
        },
        {
          id: 'country',
          label: 'Country',
          required: false,
          enabled: false,
        },
      ],
    },
  },
];

const TEMPLATES = [
  {
    id: {
      en: '6112780eaba60e5e5e6fb733',
      'pt-br': '613b39fa0e121245a6f8cbd5',
      es: '613b5d3f46e1b052f150b450',
      id: '613b5d3f46e1b052f150b456',
      fr: '613b5d3f46e1b052f150b45c',
      it: '613c76e1c61b790c721ba5e0',
      de: '613c76e1c61b790c721ba5e6',
      zh: '613c76e1c61b790c721ba5ec',
      ru: '613c76e1c61b790c721ba5f2',
    },
    title: 'Travel Booking',
    description: 'Use this simple form to get travel requirements from your customer',
    image: TravelBookIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-booking-template',
      'pt-br': 'https://whatsform.com/whatsapp-booking-template-pt',
      es: 'https://whatsform.com/whatsapp-booking-template-es',
      id: 'https://whatsform.com/whatsapp-booking-template-id',
      fr: 'https://whatsform.com/whatsapp-booking-template-fr',
      it: 'https://whatsform.com/whatsapp-booking-template-it',
      de: 'https://whatsform.com/whatsapp-booking-template-de',
      zh: 'https://whatsform.com/whatsapp-booking-template-zh',
      ru: 'https://whatsform.com/whatsapp-booking-template-ru',
    },
    key: 'travelBooking',
  },
  {
    id: {
      en: '614987e85694b4f9367d074e',
      'pt-br': '614d745b136221930fdd7a3c',
      es: '614d745b136221930fdd7a3d',
      id: '614d745b136221930fdd7a3e',
      fr: '614d745b136221930fdd7a3f',
      it: '614d745b136221930fdd7a40',
      de: '614d745b136221930fdd7a41',
      zh: '614d745b136221930fdd7a42',
      ru: '614d745b136221930fdd7a43',
    },
    title: 'Appointment Booking',
    description: 'Use this simple form to get spa bookings from your customer',
    image: AppointmentIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-appointment-template',
      'pt-br': 'https://whatsform.com/whatsapp-appointment-template-pt',
      es: 'https://whatsform.com/whatsapp-appointment-template-es',
      id: 'https://whatsform.com/whatsapp-appointment-template-id',
      fr: 'https://whatsform.com/whatsapp-appointment-template-fr',
      it: 'https://whatsform.com/whatsapp-appointment-template-it',
      de: 'https://whatsform.com/whatsapp-appointment-template-de',
      zh: 'https://whatsform.com/whatsapp-appointment-template-zh',
      ru: 'https://whatsform.com/whatsapp-appointment-template-ru',
    },
    key: 'appointmentBooking',
  },
  {
    id: {
      en: '6112743daba60e5e5e6fb4fc',
      'pt-br': '613b39fa0e121245a6f8cbd4',
      es: '613b5d3f46e1b052f150b44f',
      id: '613b5d3f46e1b052f150b455',
      fr: '613b5d3f46e1b052f150b45b',
      it: '613c76e1c61b790c721ba5df',
      de: '613c76e1c61b790c721ba5e5',
      zh: '613c76e1c61b790c721ba5eb',
      ru: '613c76e1c61b790c721ba5f1',
    },
    title: 'Contact Form',
    description: 'Get general inquires from anyone using this classic contact form',
    image: ContactIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-contact-template',
      'pt-br': 'https://whatsform.com/whatsapp-contact-template-pt',
      es: 'https://whatsform.com/whatsapp-contact-template-es',
      id: 'https://whatsform.com/whatsapp-contact-template-id',
      fr: 'https://whatsform.com/whatsapp-contact-template-fr',
      it: 'https://whatsform.com/whatsapp-contact-template-it',
      de: 'https://whatsform.com/whatsapp-contact-template-de',
      zh: 'https://whatsform.com/whatsapp-contact-template-zh',
      ru: 'https://whatsform.com/whatsapp-contact-template-ru',
    },
    key: 'contactForm',
  },
  {
    id: {
      en: '61125409c47a205ba159a7b0',
      'pt-br': '613b39fa0e121245a6f8cbd3',
      es: '613b5d3f46e1b052f150b44e',
      id: '613b5d3f46e1b052f150b454',
      fr: '613b5d3f46e1b052f150b45a',
      it: '613c76e1c61b790c721ba5de',
      de: '613c76e1c61b790c721ba5e4',
      zh: '613c76e1c61b790c721ba5ea',
      ru: '613c76e1c61b790c721ba5f0',
    },
    title: 'Customer Feedback',
    description: 'Collect feedbacks from your customers about their purchase experience',
    image: FeedBackIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-feedback-template',
      'pt-br': 'https://whatsform.com/whatsapp-feedback-template-pt',
      es: 'https://whatsform.com/whatsapp-feedback-template-es',
      id: 'https://whatsform.com/whatsapp-feedback-template-id',
      fr: 'https://whatsform.com/whatsapp-feedback-template-fr',
      it: 'https://whatsform.com/whatsapp-feedback-template-it',
      de: 'https://whatsform.com/whatsapp-feedback-template-de',
      zh: 'https://whatsform.com/whatsapp-feedback-template-zh',
      ru: 'https://whatsform.com/whatsapp-feedback-template-ru',
    },
    key: 'customerFeedback',
  },
  {
    id: {
      en: '6112406e1479ea5720fd4190',
      'pt-br': '613b39fa0e121245a6f8cbd2',
      es: '613b5d3f46e1b052f150b44d',
      id: '613b5d3f46e1b052f150b453',
      fr: '613b5d3f46e1b052f150b459',
      it: '613c76e1c61b790c721ba5dd',
      de: '613c76e1c61b790c721ba5e3',
      zh: '613c76e1c61b790c721ba5e9',
      ru: '613c76e1c61b790c721ba5ef',
    },
    title: 'Food Order',
    description: 'Connect with customers who wants to order their favourite meals',
    image: FoodIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-order-template',
      'pt-br': 'https://whatsform.com/whatsapp-order-template-pt',
      es: 'https://whatsform.com/whatsapp-order-template-es',
      id: 'https://whatsform.com/whatsapp-order-template-id',
      fr: 'https://whatsform.com/whatsapp-order-template-fr',
      it: 'https://whatsform.com/whatsapp-order-template-it',
      de: 'https://whatsform.com/whatsapp-order-template-de',
      zh: 'https://whatsform.com/whatsapp-order-template-zh',
      ru: 'https://whatsform.com/whatsapp-order-template-ru',
    },
    key: 'foodOrder',
  },
  {
    id: {
      en: '61120cec79c39550d8c2f2a5',
      'pt-br': '613b39fa0e121245a6f8cbd1',
      es: '613b5d3f46e1b052f150b44c',
      id: '613b5d3f46e1b052f150b452',
      fr: '613b5d3f46e1b052f150b458',
      it: '613c76e1c61b790c721ba5dc',
      de: '613c76e1c61b790c721ba5e2',
      zh: '613c76e1c61b790c721ba5e8',
      ru: '613c76e1c61b790c721ba5ee',
    },
    title: 'Shopping Store',
    description: 'Use this form to help customers buy clothes and accessories online',
    image: StoreIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-shopping-template',
      'pt-br': 'https://whatsform.com/whatsapp-shopping-template-pt',
      es: 'https://whatsform.com/whatsapp-shopping-template-es',
      id: 'https://whatsform.com/whatsapp-shopping-template-id',
      fr: 'https://whatsform.com/whatsapp-shopping-template-fr',
      it: 'https://whatsform.com/whatsapp-shopping-template-it',
      de: 'https://whatsform.com/whatsapp-shopping-template-de',
      zh: 'https://whatsform.com/whatsapp-shopping-template-zh',
      ru: 'https://whatsform.com/whatsapp-shopping-template-ru',
    },
    key: 'shoppingStore',
  },
  {
    id: {
      en: '61120ca679c39550d8c2f299',
      'pt-br': '613b39fa0e121245a6f8cbd0',
      es: '613b5d3f46e1b052f150b44b',
      id: '60bd966eb00331c97702f96e',
      fr: '613b5d3f46e1b052f150b457',
      it: '613c76e1c61b790c721ba5db',
      de: '613c76e1c61b790c721ba5e1',
      zh: '613c76e1c61b790c721ba5e7',
      ru: '613c76e1c61b790c721ba5ed',
    },
    title: 'Event Registration',
    description: 'Make registrations for events easier to manage and track using this form',
    image: EventIcon,
    url: {
      en: 'https://whatsform.com/whatsapp-registration-template',
      'pt-br': 'https://whatsform.com/whatsapp-registration-template-pt',
      es: 'https://whatsform.com/whatsapp-registration-template-es',
      id: 'https://whatsform.com/whatsapp-registration-template-id',
      fr: 'https://whatsform.com/whatsapp-registration-template-fr',
      it: 'https://whatsform.com/whatsapp-registration-template-it',
      de: 'https://whatsform.com/whatsapp-registration-template-de',
      zh: 'https://whatsform.com/whatsapp-registration-template-zh',
      ru: 'https://whatsform.com/whatsapp-registration-template-ru',
    },
    key: 'eventRegistration',
  },
];

const submitTextsDefault = {
  en: 'Submit',
  'pt-br': 'Enviar',
  es: 'Enviar',
  id: 'Kirim',
  fr: 'Envoyer',
  it: 'Invia',
  de: 'Einreichen',
  ar: 'إرسال',
  zh: '上提交',
  ru: 'Отправить',
};

const submitActionTexts = {
  en: 'on WhatsApp',
  'pt-br': 'No WhatsApp',
  es: 'por WhatsApp',
  id: 'di WhatsApp',
  fr: 'sur WhatsApp',
  it: 'su WhatsApp',
  de: 'auf WhatsApp',
  ar: 'على الواتساب',
  zh: '在 WhatsApp',
  ru: 'в WhatsApp',
};

export const questionLabelTexts = {
  en: {
    HEADER: 'Add title here',
    TEXT: 'Type a question',
    NUMBER: 'Type a question',
    RADIO: 'Choose one option',
    CHECKBOX: 'Choose multiple options',
    DROPDOWN: 'Choose an option from dropdown',
    RATING: 'Rate your experience',
    DATE: 'Choose a date or date and time',
    IMAGE: 'Add an image here',
    VIDEO: 'Add a video here',
    EMAIL: 'Enter your email',
    PHONE: 'Enter your phone number',
    FILE: 'Choose a file for upload',
    FORMULA: 'Calculated value',
    PAYMENT: 'Payment',
    ADDRESS: 'Address',
    DEFAULT: 'Type a question',
  },
  'pt-br': {
    HEADER: 'Adicione o título aqui',
    TEXT: 'Digite uma pergunta',
    NUMBER: 'Digite uma pergunta',
    RADIO: 'escolha uma opção',
    CHECKBOX: 'Escolha várias opções',
    DROPDOWN: 'Escolha uma opção no menu suspenso',
    RATING: 'Avalie sua experiência',
    DATE: 'Escolha uma data ou data e hora',
    IMAGE: 'Adicione uma imagem aqui',
    VIDEO: 'Adicione um vídeo aqui',
    EMAIL: 'Digite seu e-mail',
    PHONE: 'Digite seu número de telefone',
    FILE: 'Escolha um arquivo para upload',
    FORMULA: 'valor calculado',
    PAYMENT: 'Pagamento',
    ADDRESS: 'Endereço',
    DEFAULT: 'Digite uma pergunta',
  },
  es: {
    HEADER: 'Añade un título aquí',
    TEXT: 'Escriba una pregunta',
    NUMBER: 'Escriba una pregunta',
    RADIO: 'Elige una opción',
    CHECKBOX: 'Elige múltiples opciones',
    DROPDOWN: 'Elija una opción del menú desplegable',
    RATING: 'Califica tu experiencia',
    DATE: 'Elige una fecha o fecha y hora',
    IMAGE: 'Añade una imagen aquí',
    VIDEO: 'Agrega un video aquí',
    EMAIL: 'Introduce tu correo electrónico',
    PHONE: 'Ingrese su número telefónico',
    FILE: 'Elija un archivo para cargar',
    FORMULA: 'Valor calculado',
    ADDRESS: 'Endereço',
    DEFAULT: 'Escriba una pregunta',
  },
  id: {
    HEADER: 'Add title here',
    TEXT: 'Ketik pertanyaan',
    NUMBER: 'Ketik pertanyaan',
    RADIO: 'Pilih satu opsi',
    CHECKBOX: 'Pilih beberapa opsi',
    DROPDOWN: 'Pilih opsi dari dropdown',
    RATING: 'Nilai pengalaman Anda',
    DATE: 'Pilih tanggal atau tanggal dan waktu',
    IMAGE: 'Tambahkan gambar di sini',
    VIDEO: 'Tambahkan video di sini',
    EMAIL: 'Masukkan email Anda',
    PHONE: 'Masukkan nomor telepon Anda',
    FILE: 'Pilih file untuk diunggah',
    FORMULA: 'Nilai yang dihitung',
    PAYMENT: 'Payment',
    ADDRESS: 'Alamat',
    DEFAULT: 'Ketik pertanyaan',
  },
  fr: {
    HEADER: 'Ajouter le titre ici',
    TEXT: 'Taper une question',
    NUMBER: 'Taper une question',
    RADIO: 'Choisissez une option',
    CHECKBOX: 'Choisissez plusieurs options',
    DROPDOWN: 'Choisissez une option dans la liste déroulante',
    RATING: 'Évaluez votre expérience',
    DATE: 'Choisissez une date ou une date et une heure',
    IMAGE: 'Ajouter une image ici',
    VIDEO: 'Ajouter une vidéo ici',
    EMAIL: 'Entrer votre Email',
    PHONE: 'Entrez votre numéro de téléphone',
    FILE: 'Choisissez un fichier à télécharger',
    FORMULA: 'Valeur calculée',
    PAYMENT: 'Paiement',
    ADDRESS: 'Adresse',
    DEFAULT: 'Taper une question',
  },
  it: {
    HEADER: 'Aggiungi il titolo qui',
    TEXT: 'Digita una domanda',
    NUMBER: 'Digita una domanda',
    RADIO: "Scegli un'opzione",
    CHECKBOX: 'Scegli più opzioni',
    DROPDOWN: "Scegli un'opzione dal discesa",
    RATING: 'Valuta la tua esperienza',
    DATE: 'Scegli una data o una data e ora',
    IMAGE: "Aggiungi un'immagine qui",
    VIDEO: 'Aggiungi un video qui',
    EMAIL: 'Inserisci il tuo indirizzo email',
    PHONE: 'Inserisci il tuo numero di telefono',
    FILE: 'Scegli un file per il caricamento',
    FORMULA: 'Valore calcolato',
    PAYMENT: 'Pagamento',
    ADDRESS: 'Indirizzo',
    DEFAULT: 'Digita una domanda',
  },
  de: {
    HEADER: 'Fügen Sie hier den Titel hinzu',
    TEXT: 'Geben Sie eine Frage ein',
    NUMBER: 'Geben Sie eine Frage ein',
    RADIO: 'Wählen Sie eine Option',
    CHECKBOX: 'Wählen Sie mehrere Optionen',
    DROPDOWN: 'Wählen Sie eine Option aus Dropdown',
    RATING: 'Bewerten Sie Ihre Erfahrung',
    DATE: 'Wählen Sie ein Datum oder Datum und Uhrzeit',
    IMAGE: 'Fügen Sie hier ein Bild hinzu',
    VIDEO: 'Fügen Sie hier ein Video hinzu',
    EMAIL: 'Geben sie ihre E-Mail Adresse ein',
    PHONE: 'Trage deine Telefonnummer ein',
    FILE: 'Wählen Sie eine Datei zum Upload aus',
    FORMULA: 'Berechneter Wert',
    PAYMENT: 'Zahlung',
    ADDRESS: 'Adresse',
    DEFAULT: 'Geben Sie eine Frage ein',
  },
  zh: {
    HEADER: '在这里添加标题',
    TEXT: '键入问题',
    NUMBER: '键入问题',
    RADIO: '选择一个选项',
    CHECKBOX: '选择多个选项',
    DROPDOWN: '从下拉列表中选择一个选项',
    RATING: '评分您的经验',
    DATE: '选择日期或日期',
    IMAGE: '在这里添加图像',
    VIDEO: '在这里添加视频',
    EMAIL: '输入你的电子邮箱',
    PHONE: '输入你的电话号码',
    FILE: '选择一个用于上传的文件',
    FORMULA: '计算值',
    PAYMENT: '付款',
    ADDRESS: '地址',
    DEFAULT: '键入问题',
  },
  ru: {
    HEADER: 'Добавьте заголовок здесь',
    TEXT: 'Введите вопрос',
    NUMBER: 'Введите вопрос',
    RADIO: 'Выберите один вариант',
    CHECKBOX: 'Выберите несколько вариантов',
    DROPDOWN: 'Выберите вариант из выпадающего списка',
    RATING: 'Оцените свой опыт',
    DATE: 'Выберите дату или дату и время',
    IMAGE: 'Добавьте изображение здесь',
    VIDEO: 'Добавьте видео здесь',
    EMAIL: 'Введите адрес электронной почты',
    PHONE: 'Введите свой номер телефона',
    FILE: 'Выберите файл для загрузки',
    FORMULA: 'Вычисленное значение',
    PAYMENT: 'Оплата',
    ADDRESS: 'Адрес',
    DEFAULT: 'Введите вопрос',
  },
  ar: {
    HEADER: 'أضف العنوان هنا',
    TEXT: 'اكتب سؤال',
    NUMBER: 'اكتب سؤال',
    RADIO: 'اختر خيارًا واحدًا',
    CHECKBOX: 'اختر خيارات متعددة',
    DROPDOWN: 'اختر خيارًا من القائمة المنسدلة',
    RATING: 'قيم تجربتك',
    DATE: 'اختر تاريخًا أو تاريخًا ووقتًا',
    IMAGE: 'أضف صورة هنا',
    VIDEO: 'أضف فيديو هنا',
    EMAIL: 'أدخل بريدك الإلكتروني',
    PHONE: 'أدخل رقم هاتفك',
    FILE: 'اختر ملفًا للتحميل',
    FORMULA: 'القيمة المحسوبة',
    PAYMENT: 'دفع',
    ADDRESS: 'العنوان',
    DEFAULT: 'اكتب سؤال',
  },
};

export {
  LANGUAGES,
  GOOGLE_AUTH_LINK,
  GOOGLE_SHEET_AUTH_LINK,
  createMenuList,
  ITEMS,
  ADVANCED_ITEMS,
  TEMPLATES,
  ToolBarHeaderMap,
  submitTextsDefault,
  submitActionTexts,
};
